/**
 * @generated SignedSource<<1cc57cb07f795c3c670ae38de87ffe5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SubscriptionUpdateInput = {
  item_price_id: string;
};
export type SubscriptionUpdateMutation$variables = {
  input: SubscriptionUpdateInput;
};
export type SubscriptionUpdateMutation$data = {
  readonly action_subscription_update: {
    readonly account: {
      readonly id: number;
      readonly subscription: any | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type SubscriptionUpdateMutation = {
  response: SubscriptionUpdateMutation$data;
  variables: SubscriptionUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SubscriptionUpdateOutput",
    "kind": "LinkedField",
    "name": "action_subscription_update",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "accounts",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subscription",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscriptionUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SubscriptionUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cccc78f4e19b7714d68698b6470031eb",
    "id": null,
    "metadata": {},
    "name": "SubscriptionUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation SubscriptionUpdateMutation(\n  $input: SubscriptionUpdateInput!\n) {\n  action_subscription_update(input: $input) {\n    account {\n      id\n      subscription\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "74727bdae4d3ae8911645fb7a47b3c13";

export default node;
